/*
SiderConversations.js
侧边栏的会话管理
 */

import React, {useEffect, useRef, useState} from 'react';
import {Modal, Row, Col, Form, Input, Space, Button, message} from 'antd';
import {Conversations} from '@ant-design/x';
import {DeleteOutlined, EditOutlined} from '@ant-design/icons';

import {ACTIVE_SESSION_DEFAULT_VALUE, ACTIVE_SESSION_KEY} from "../../../Common/constants";

const {TextArea} = Input;

const SiderConversations = ({sessions = [], deleteSession, handleChangeSession, renameSession, isMobile, drawerOnClose}) => {
    // sessions数据，标题
    const [items, setItems] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSession, setSelectedSession] = useState({});
    const [activeKey, setActiveKey] = useState(ACTIVE_SESSION_DEFAULT_VALUE);
    // 当前正在删除的session的key
    const deleteKey = useRef(ACTIVE_SESSION_DEFAULT_VALUE);

    const [form] = Form.useForm();

    // 载入sessions
    useEffect(() => {
        // 转换为新的数组，变为 key 和 content
        const newList = sessions.map(item => ({
            key: item.sessionID,
            label: item.title,
        }));
        setItems(newList);
        // 设置当前激活的会话
        setActiveKey(sessionStorage.getItem(ACTIVE_SESSION_KEY));
    }, [sessions]);

    // menu中item的更多操作
    const menuConfig = (conversation) => ({
        items: [
            {
                label: '重命名',
                key: 'rename',
                icon: <EditOutlined/>,
            },
            {
                label: '删除会话',
                key: 'delete',
                icon: <DeleteOutlined/>,
                danger: true,
            },
        ],
        onClick: (menuInfo) => {
            // 删除会话
            if (menuInfo.key === 'delete') {
                deleteKey.current = conversation.key
                deleteSession(conversation.key);
            }
            // 重命名
            if (menuInfo.key === 'rename') {
                setSelectedSession(conversation);
                setIsModalOpen(true);
            }
        },
    });

    // 重命名form提交按钮
    const formCommit = (value) => {
        renameSession({sessionID: selectedSession.key, newTitle: value.new_title});
        // 关闭模态框
        setIsModalOpen(false);
        // 重置表单
        form.resetFields();
        return true;
    };

    // 取消按钮点击
    const cancelBtnClicked = () => {
        // 重置表单
        form.resetFields();
        setIsModalOpen(false);
    };

    // 点击会话按钮
    /*
    由于再删除的时候，sessions会变化，会激活handleOnActiveChange方法。
    但是删除的时候，是不希望变更激活选项的。所以做了如下判断：
    1.当当前删除的id即key等于当前正在激活的会话时，激活的操作在SiderMenu就做了处理，这里直接跳过，不要做任何操作；
    2.当删除的id不是当前激活的，跳过
    3.当只是点击事件，设置新的激活
     */
    const handleOnActiveChange = (value) => {
        if (deleteKey.current === ACTIVE_SESSION_DEFAULT_VALUE) {
            // 当前并不是删除态，证明只是一个点击事件
            sessionStorage.setItem(ACTIVE_SESSION_KEY, value)
            setActiveKey(value);
            handleChangeSession();
        } else {
            deleteKey.current = ACTIVE_SESSION_DEFAULT_VALUE;
            return;
        }
        // 如果是移动端，退出drawer抽屉菜单
        if (isMobile === true) {
            drawerOnClose();
        }
    };

    return (
        <div>
            <Conversations menu={isMobile ? null : menuConfig} items={items} style={{overFlow: 'auto'}}
                           onActiveChange={handleOnActiveChange} activeKey={activeKey}/>
            <Modal title="添加" open={isModalOpen} footer={null} closable={false}>
                <Row justify='center' style={{marginTop: 20}}>
                    <Col span={23}>
                        <Form name='rename' form={form} layout='vertical' onFinish={formCommit}>
                            <Form.Item name='old_title' label='旧名称:' initialValue={selectedSession.label}>
                                <TextArea disabled autoSize variant="borderless" style={{color: '#000'}}/>
                            </Form.Item>
                            <Form.Item name='new_title' label='新名称:'
                                       rules={[{required: true, message: '请输入新名称!'},]}>
                                <TextArea placeholder='输入新名称' showCount maxLength='20'
                                          allowClear autoSize/>
                            </Form.Item>
                            <Form.Item style={{textAlign: 'right'}}>
                                <div style={{height: 20}}></div>
                                <Space size='middle'>
                                    <Button onClick={cancelBtnClicked}>取消</Button>
                                    <Button type='primary' htmlType='submit'>确定</Button>
                                </Space>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Modal>
        </div>
    );
};

export default SiderConversations;